import { Gender, GuardianRelation } from '@dreryk/egabinet-patient-frontend-api';

import { RadioGroupItem } from '@dreryk/react-components';

import { guardiansTranslationKeys } from '../../translations';

export const useRelationCodesRadioItems = (guardianGender: Gender | unknown): RadioGroupItem<GuardianRelation>[] => [
   {
      id: 'MOTHER',
      label: guardiansTranslationKeys.mother,
      disabled: Boolean(guardianGender && guardianGender !== 'WOMAN'),
   },
   {
      id: 'FATHER',
      label: guardiansTranslationKeys.father,
      disabled: Boolean(guardianGender && guardianGender !== 'MAN'),
   },
   {
      id: 'NEXT_OF_KIN',
      label: guardiansTranslationKeys.nextOfKin,
   },
   {
      id: 'ACTUAL_GUARDIAN',
      label: guardiansTranslationKeys.actualGuardian,
   },
];
